import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, of} from 'rxjs';
import Pagination from '../../model/pagination';
import {environment} from '../../environments/environment';
import QueryEncoder from '../queryEncoder';
import {catchError, switchMap} from 'rxjs/operators';
import DoingModel from '../../model/doing.model';
import GenericCrudService from "../genericCrud.service";
import CooperationModel from "../../model/cooperation.model";

@Injectable()
export default class DoingService extends GenericCrudService<DoingModel> {
  private allDoingsSubject = new BehaviorSubject<DoingModel[]>([]);
  public allDoings$ = this.allDoingsSubject.asObservable();

    constructor(http: HttpClient) {
        super(http);
    }

  public create(item: DoingModel): Observable<DoingModel> {
    return super.create(item).pipe(
        switchMap(doing => {
          let doings = this.allDoingsSubject.getValue();
          doings.unshift(doing);
          this.allDoingsSubject.next(doings);
          return of(doing);
        })
    );
  }

  public createFollowUp(doing: DoingModel, forDoing: DoingModel): Observable<DoingModel> {
    return this.http
      .post<DoingModel>(environment.apiUrl + '/doings/' + forDoing.id + '/follow-up', doing).pipe(
        switchMap(doing => {
          let doings = this.allDoingsSubject.getValue();
          let parent = this.findRecursive(doings, forDoing);
          if(parent) {
            Object.assign(parent, doing);
          }
          this.allDoingsSubject.next(doings);
          return of(doing);
        })
      );
  }

  private findRecursive(doings: DoingModel[], doing: DoingModel) {
    for(let d of doings) {
      if(d.id == doing.id) {
        return d;
      } else {
        if(d.predecessor) {
          let foundSub = this.findRecursive([d.predecessor], doing);
          if(foundSub) {
            return foundSub;
          }
        }
      }
    }
    return null;
  }

  public delete(item: DoingModel): Observable<boolean> {
    return super.delete(item).pipe(
        switchMap(result => {
          let q = {
            page: 1,
            limit: 99,
            sorting: { created: 'desc' }
          };

          this.http
              .get<Pagination<DoingModel>>(environment.apiUrl + '/doings?' + QueryEncoder.encodeURI(q)).subscribe(result => {
            this.allDoingsSubject.next(result.results);
          });
          return of(true);
        }),
        catchError(result => of(false))
    );
  }

  public check(doing: DoingModel): Observable<boolean> {
    return this.http.post(environment.apiUrl + '/doings/' + doing.id + '/check', {}).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }

  public assignCooperation(doing: DoingModel, cooperation: CooperationModel): Observable<DoingModel> {
      return this.http.post<DoingModel>(environment.apiUrl + '/doings/' + doing.id + '/assign-cooperation', {
          cooperationId: cooperation.id
      });
  }

  public uncheck(doing: DoingModel): Observable<boolean> {
    return this.http.post(environment.apiUrl + '/doings/' + doing.id + '/uncheck', {}).pipe(
      switchMap(result => of(true)),
      catchError(result => of(false))
    );
  }

  getApiName() {
      return 'doings';
  }
}
